<template>
  <div class="pie-box">
    <div :class="className" :id="id" :style="{ height: height, width: width }" />
  </div>
</template>

<script>
export default {
  // 河流传播图
  name: "ThemeRiver",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "300px"
    },
    chartData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    if (this.chartData) {
      this.initChart();
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData() {      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.initChart();
    }
  },
  methods: {
    initChart() {
      let me = this
      var rich = this.rich

      var option = option = {
        backgroundColor: "rgba(0,0,0,0)",
        color: ["#37A2DA", "#32C5E9", "#67E0E3", "#9FE6B8", "#FFDB5C", "#ff9f7f", "#fb7293", "#E062AE", "#E690D1", "#e7bcf3", "#9d96f5", "#8378EA", "#96BFFF"],

        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: 'rgba(255,255,0,0.8)',
              width: 1,
              type: 'solid'
            }
          }
        },

        legend: {

          top: '4%',
          textStyle: {
            color: '#fff',
          },
          data: ['DQ', 'TY', 'SS', 'QG', 'SY', 'DD']
        },

        singleAxis: {
          top: 90,
          bottom: 90,
          left: 100,
          right: 100,
          "axisLine": {
            lineStyle: {
              color: '#999'
            }
          },
          axisTick: {},
          axisLabel: {},
          type: 'time',
          axisPointer: {
            animation: true,
            label: {
              show: true
            }
          },
          splitLine: {

            show: true,
            lineStyle: {
              type: 'dashed',

              opacity: 0.5,
            }
          }
        },

        series: [{
          type: 'themeRiver',
          label: {
            normal: {
              show: false,
              position: 'left'
            }
          },
          itemStyle: {
            emphasis: {
              shadowBlur: 20,
              shadowColor: 'rgba(0, 0, 0, 0.8)'
            }
          },
          data: this.chartData
        }]
      }

      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(option);
    }
  }
};
</script>
<!--<style scoped lang="less">-->
<!--.pie-box {-->
  <!--width: 100%;-->
  <!--height: 100%;-->
  <!--position: relative;-->
<!--}-->
<!--</style>-->
